import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { SectionLabel } from '../ui/SectionLabel';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

export const Location = () => (
  <section id="location" className="py-28 md:py-36 bg-charcoal text-white">
    <div className="container mx-auto px-6 md:px-14">
      <FadeIn className="text-center mb-20">
        <SectionLabel light>Find Us</SectionLabel>
        <h2 className="font-serif text-4xl md:text-5xl text-white">
          Visit Us on Amoy Street
        </h2>
      </FadeIn>

      <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-start">
        <div className="lg:col-span-2 space-y-10">
          <FadeIn direction="right" delay={0.1}>
            <div className="flex gap-5">
              <SafeIcon icon={FiIcons.FiMapPin} className="text-gold text-xl flex-shrink-0 mt-1" />
              <div>
                <p className="text-[10px] tracking-[0.25em] uppercase text-gold/60 mb-2">Address</p>
                <p className="text-white/80 font-light leading-relaxed">
                  Maison De Charm<br />
                  85 Amoy St<br />
                  Singapore 069904
                </p>
              </div>
            </div>
          </FadeIn>

          <FadeIn direction="right" delay={0.2}>
            <div className="flex gap-5">
              <SafeIcon icon={FiIcons.FiClock} className="text-gold text-xl flex-shrink-0 mt-1" />
              <div>
                <p className="text-[10px] tracking-[0.25em] uppercase text-gold/60 mb-2">Opening Hours</p>
                <div className="text-white/80 font-light text-sm leading-relaxed">
                  <p>Mon - Fri: 12.00pm - 2.00pm (Lunch,Last Seating 2.00pm)</p>
                  <p>Mon - Fri: 6.30pm - 9.00pm (Dinner,Last Seating 8.00pm)</p>
                  <p>Sat: Open for private events only</p>
                  <p>Sun & PH: Closed</p>
                </div>
              </div>
            </div>
          </FadeIn>

          <FadeIn direction="right" delay={0.3}>
            <div className="flex gap-5">
              <SafeIcon icon={FiIcons.FiPhone} className="text-gold text-xl flex-shrink-0 mt-1" />
              <div>
                <p className="text-[10px] tracking-[0.25em] uppercase text-gold/60 mb-2">Reservations</p>
                <p className="text-white/80 font-light">+65 8765 5023</p>
                <p className="text-white/80 font-light">reservation@maisondecharm.com</p>
              </div>
            </div>
          </FadeIn>
        </div>

        <FadeIn className="lg:col-span-3" delay={0.2} direction="left">
          <div className="overflow-hidden shadow-2xl" style={{ height: '420px' }}>
            <iframe
              title="Maison De Charm Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3988.8166234982!2d103.84628731475399!3d1.2807499990639!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da19073b3c98a7%3A0xacd7d6e76e9b8a9a!2sAmoy%20St%2C%20Singapore!5e0!3m2!1sen!2ssg!4v1620000000000!5m2!1sen!2ssg"
              width="100%"
              height="100%"
              style={{ border: 0, filter: 'grayscale(80%) contrast(1.1) brightness(0.85)' }}
              allowFullScreen=""
              loading="lazy"
            />
          </div>
        </FadeIn>
      </div>
    </div>
  </section>
);